/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SystemModule
 */

import {
    Component,
    Input,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import { ITelemetryConfiguration } from 'generated-types';
import { TelemetryConfiguration } from 'object-types';
import './telemetry-config.component.less';
import * as globalL10n from 'global-l10n';
import * as l10n from './telemetry-config.l10n';
import { TELEMETRY_CEIP_URL } from './telemetry-config.constants';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;
const { ...globalL10nKeys } = globalL10n;

/**
 * @description Component for Telemetry config in System Settings Modal.
 * @author Shubam Bindal
 */
@Component({
    selector: 'telemetry-config',
    templateUrl: './telemetry-config.component.html',
})
export class TelemetryConfigComponent {
    /**
     * Telemetry Config.
     */
    @Input()
    public telemetryConfig: ITelemetryConfiguration;

    /**
     * Get keys from source bundles for template usage.
     */
    public readonly l10nKeys = l10nKeys;

    /**
     * Object type string for template usage.
     */
    public readonly objectType = TelemetryConfiguration;

    public readonly ceipUrl = TELEMETRY_CEIP_URL;

    public readonly globalL10nKeys = globalL10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}
